import styled from 'styled-components'

export const SectionDescription = styled.div`
  margin-bottom: 16px;
`

export const SectionInput = styled.div`
  max-width: 560px;
`
